var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircledArrow = function SvgCircledArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5h20M22.857 13 30 20.143M22.857 27.286 30 20.143",
    stroke: "currentColor"
  })));
};

export { SvgCircledArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjE5LjUiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CiAgICA8cGF0aCBkPSJNMTAgMjAuNDk5N0gzMCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KICAgIDxwYXRoIGQ9Ik0yMi44NTc0IDEzTDMwLjAwMDMgMjAuMTQyOSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KICAgIDxwYXRoIGQ9Ik0yMi44NTc0IDI3LjI4NjFMMzAuMDAwMyAyMC4xNDMzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";